// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

const PgLogsController = function ($scope, $http, PgApplicationLogs) {
    $scope.loading = true;

    $scope.logLevels = [];
    
    $scope.logs = [];
    const getEmptyFilter = function () {
        return {
            Level: '',
            Message: '',
            After: '',
            Before: '',
        };
    };

    $scope.filter = getEmptyFilter();

    $scope.loadPage = function () {
        $http.get('/api/v1/paymentGateway/logs/loglevels', {cache: true}).then(function (result) {
            $scope.logLevels = result.data;
        });
    }

    $scope.loadPage();

    $scope.fetchLogs = function () {
        $scope.loading = true;
        $scope.logs = $scope.paginator(function(options, callback) {
                return PgApplicationLogs.query(options, function()
                {
                    callback();
                    $scope.loading = false;
                });
            },
            $scope.filter,
            100);
    }

    $scope.fetchLogs();

    $scope.resetFilter = function () {
        $scope.filter = getEmptyFilter();
    };
};
PgLogsController.$inject = ["$scope", "$http", "PgApplicationLogs"];
